import * as React from 'react';
import { useBlocker } from 'react-router-dom';
export var UNSAVED_CHANGES_TITLE = 'Leave without submitting?';
export var UNSAVED_CHANGES_MESSAGE = 'This application is not saved anywhere and cannot be resumed later. ' +
    'If you leave now you will lose all the information you have entered.';
export var useUnsavedChangesGuard = function (isEnabled) {
    var shouldBlock = React.useCallback(function (_a) {
        var currentLocation = _a.currentLocation, nextLocation = _a.nextLocation;
        return isEnabled && currentLocation.pathname !== nextLocation.pathname;
    }, [isEnabled]);
    var blocker = useBlocker(shouldBlock);
    React.useEffect(function () {
        if (!isEnabled) {
            return undefined;
        }
        var warnBeforeUnload = function (event) {
            event.preventDefault();
            event.returnValue = UNSAVED_CHANGES_MESSAGE;
            return UNSAVED_CHANGES_MESSAGE;
        };
        window.addEventListener('beforeunload', warnBeforeUnload);
        return function () { return window.removeEventListener('beforeunload', warnBeforeUnload); };
    }, [isEnabled]);
    React.useEffect(function () {
        if (!isEnabled && blocker.state === 'blocked') {
            blocker.reset();
        }
    }, [blocker, isEnabled]);
    var confirmLeave = React.useCallback(function () {
        var _a;
        (_a = blocker.proceed) === null || _a === void 0 ? void 0 : _a.call(blocker);
    }, [blocker]);
    var cancelLeave = React.useCallback(function () {
        var _a;
        (_a = blocker.reset) === null || _a === void 0 ? void 0 : _a.call(blocker);
    }, [blocker]);
    return { isLeaveBlocked: blocker.state === 'blocked', confirmLeave: confirmLeave, cancelLeave: cancelLeave };
};
export default useUnsavedChangesGuard;
